import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { ContactEntity } from './contact.entity';
import { JobEntity } from './job.entity';

/**
 * PD-17093 — a person on a job with their role there ("Superintendent",
 * "Project manager"). The role is free text: it is the person's part in this
 * job, not one of their contact roles at the customer.
 */
@Index('job_contact__job_contact', ['fkJobId', 'fkContactId'], { unique: true })
@Index('job_contact__fk_contact__id', ['fkContactId'], {})
@Entity('job_contact')
export class JobContactEntity extends BaseEntity {
	@Column('int', { name: 'fk_job__id', unsigned: true })
	public fkJobId!: number;

	@Column('int', { name: 'fk_contact__id', unsigned: true })
	public fkContactId!: number;

	@Column('varchar', { name: 'role', length: 64, nullable: true })
	public role!: string | null;

	@ManyToOne(() => JobEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_job__id', referencedColumnName: 'id' }])
	public job!: JobEntity;

	@ManyToOne(() => ContactEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_contact__id', referencedColumnName: 'id' }])
	public contact!: ContactEntity;
}
